// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"3bbe57f5","418":"30889fa4"}[chunkId] + ".js";
};